const pushStateOrig = window.history.pushState;
function subscribePushStateGlobal(callback) {
    if (!window.history) {
        return null;
    }
    window.history.pushState = function pushState() {
        pushStateOrig.apply(this, arguments);
        callback.apply(this, arguments);
    };
    return () => {
        window.history.pushState = pushStateOrig;
    };
}
let unsubscribeGlobal;
const subscribers = [];
export function subscribePushState(callback) {
    if (!unsubscribeGlobal) {
        unsubscribeGlobal = subscribePushStateGlobal(function onPushState() {
            for (let i = 0, len = subscribers.length; i < len; i++) {
                subscribers[i].apply(null, arguments);
            }
        });
    }
    subscribers.push(callback);
    return () => {
        const index = subscribers.indexOf(callback);
        if (index >= 0) {
            subscribers.splice(index, 1);
        }
        if (unsubscribeGlobal && subscribers.length === 0) {
            unsubscribeGlobal();
            unsubscribeGlobal = null;
        }
    };
}
